export const LoadingMap = () => {
  return (
    <div className="loading-map d-flex justify-content-center align-items-center">
      <div className="text-center">
        <h3>please wait</h3>
        <span>calculating...</span>
      </div>
    </div>
  );
};
